import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import ModificaProdottiNEW from "../ModificaProdottiNEW";
import prodVuoto from "../../prodottoVuoto";
import { BlockSkeleton } from "../../interfaccia/loading";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import useSchedaArticolo from "./useSchedaArticolo";

export default function SchedaArticoloOverlay({ scheda, utente, listaNomiProdotto, setProductFunction, onChiusa }) {
  const callbacks = useRef();
  callbacks.current = { setProductFunction, onChiusa };
  const contenitore = useRef();
  useEffect(() => {
    const precedente = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    contenitore.current?.focus();
    return () => {
      document.body.style.overflow = overflow;
      callbacks.current.setProductFunction(prodVuoto);
      callbacks.current.onChiusa?.();
      precedente?.focus?.();
    };
  }, []);
  return <div ref={contenitore} tabIndex={-1} role="dialog" aria-modal="true" aria-label={`Articolo ${scheda.articolo}`}
    className="fixed top-0 left-0 w-100 h-100 flex flex-column z-999 sfondoBiancoTema" style={{ overflow: "auto" }}>
    {scheda.prodotto ? <ModificaProdottiNEW key={scheda.articolo} prodotto={scheda.prodotto} setProductFunction={setProductFunction}
      utente={utente} listaNomiProdotto={listaNomiProdotto} onClose={scheda.chiudi} /> : <div className="pa3">
      <h2>Articolo {scheda.articolo}</h2>
      {scheda.caricamento && <BlockSkeleton height={320} />}
      {scheda.errore && <p role="alert">{scheda.errore}</p>}
      <button className={stilePulsanti.buttonClassesWhite} onClick={scheda.chiudi}>Chiudi</button>
    </div>}
  </div>;
}

export function SchedaArticoloStandalone(props) {
  const { codVS } = useParams();
  const scheda = useSchedaArticolo({ codVS, setProductFunction: props.setProductFunction });
  return <SchedaArticoloOverlay {...props} scheda={scheda} />;
}
